import script from "./WorkspaceScalesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkspaceScalesPage.vue?vue&type=script&setup=true&lang=ts"

import "./WorkspaceScalesPage.vue?vue&type=style&index=0&id=a315980e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a315980e"]])

export default __exports__